/**
 * QueryClient TanStack Query — instance unique partagée.
 *
 * @remarks
 * Tous les hooks `useQuery` / `useMutation` du projet utilisent ce client
 * via le `QueryProvider` (cf. `app/providers/QueryProvider.tsx`).
 *
 * **Defaults** :
 * - `staleTime: 30s` — données considérées fraîches 30s. Évite les refetch
 *   spammés sur navigation rapide.
 * - `retry: 1` en query (vs 3 par défaut) — fail-fast en dev, pas de boucle
 *   de retries qui masque les vrais problèmes.
 * - `refetchOnWindowFocus: false` en dev — évite le bruit pendant qu'on code.
 *   À activer en prod pour le confort utilisateur.
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      retry: 1,
      refetchOnWindowFocus: import.meta.env.PROD,
    },
    mutations: {
      retry: 0,
    },
  },
});
